import ReactDOM from "react-dom";

// Usando o svg estático, nós controlaremos a animação no CSS
import logoImg from "../../assets/symbol-purple.svg";

import { Container, SpinnerWrapper, SpinnerSvg, SpinnerCircle, LogoImage } from "./styles";

interface LoadingProps {
  loading: boolean;
  text?: string;
  numberOfDots?: number;
  dotSymbol?: string;
  global?: boolean;
}

export function Loading({ loading, global = true }: LoadingProps) {

  const content = (
    <Container is_loading={loading} is_global={global}>
      <SpinnerWrapper>
        <SpinnerSvg viewBox="25 25 50 50">
          <SpinnerCircle cx="50" cy="50" r="20" fill="none" strokeWidth="3.5" strokeMiterlimit="10" />
        </SpinnerSvg>
        <LogoImage src={logoImg} alt="FixIt Logo" />
      </SpinnerWrapper>
    </Container>
  );

  return global ? ReactDOM.createPortal(content, document.body) : content;
}
